import React, { useEffect } from 'react';
import { Card, Skeleton } from 'antd';
import { trpc } from '../../lib/trpc';
import CompanySettingsTab from '../../components/company/CompanySettingsTab';
import { PageHeader, PageContainer, DevFilePathBadge } from '../../components/common';
import { PURCHASE_ORDER_APPROVAL_SETTINGS_ANCHOR_ID } from '../../constants/purchaseOrderApprovalSettings';

const AdvancedSettingsPage: React.FC = () => {
  const { data: company, isLoading } = trpc.company.getCurrentCompany.useQuery();
  const { data: currentUser } = trpc.user.getProfile.useQuery();
  const isAdmin = currentUser?.role === 'admin';
  const isManager = currentUser?.role === 'admin' || currentUser?.role === 'manager';

  useEffect(() => {
    if (isLoading || window.location.hash !== `#${PURCHASE_ORDER_APPROVAL_SETTINGS_ANCHOR_ID}`) {
      return;
    }

    let retryCount = 0;
    let timerId: number | undefined;
    const maxRetryCount = 60;
    const scrollToApprovalSettings = () => {
      const target = document.getElementById(PURCHASE_ORDER_APPROVAL_SETTINGS_ANCHOR_ID);
      if (target) {
        // Content above this section loads asynchronously, so keep the anchor pinned briefly.
        target.scrollIntoView({
          behavior: 'auto',
          block: 'start',
        });
      }

      retryCount += 1;
      if (retryCount <= maxRetryCount) {
        timerId = window.setTimeout(scrollToApprovalSettings, 100);
      }
    };

    timerId = window.setTimeout(scrollToApprovalSettings, 0);

    return () => {
      if (timerId !== undefined) {
        window.clearTimeout(timerId);
      }
    };
  }, [isLoading]);

  if (isLoading) {
    return (
      <PageContainer>
        <PageHeader
          title="詳細設定"
          subtitle="会社全体に適用される詳細な設定を管理します"
        />
        <Card>
          <Skeleton active />
        </Card>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <DevFilePathBadge filePath="client/src/pages/settings/AdvancedSettingsPage.tsx" />
      <PageHeader
        title="詳細設定"
        subtitle="会社全体に適用される詳細な設定を管理します"
      />
      <CompanySettingsTab company={company} isManager={isManager} isAdmin={isAdmin} />
    </PageContainer>
  );
};

export default AdvancedSettingsPage;
